import { Popover as MuiPopover, PopoverProps as MuiPopoverProps, PopoverOrigin } from '@material-ui/core';
import { FC } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import { styles } from './Popover.styles';

export interface PopoverProps
  extends Pick<MuiPopoverProps, 'PaperProps' | 'onClick' | 'onClose' | 'onExited'>,
    WithStyles<typeof styles> {
  anchorEl: HTMLElement | null;
  anchorOrigin?: PopoverOrigin;
  className?: string;
  elevation?: number;
  open: boolean;
  transformOrigin?: PopoverOrigin;
}

const PopoverComponent: FC<PopoverProps> = ({
  anchorEl,
  anchorOrigin,
  children,
  classes,
  className,
  elevation,
  open,
  transformOrigin,
  ...muiPopoverProps
}) => {
  return (
    <MuiPopover
      {...muiPopoverProps}
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin ?? { vertical: 'top', horizontal: 'center' }}
      classes={{ paper: className || classes.paper }}
      elevation={elevation ?? 0}
      open={open}
      transformOrigin={transformOrigin ?? { vertical: 'bottom', horizontal: 'center' }}
    >
      {children}
    </MuiPopover>
  );
};

export const Popover = withStyles(styles)(PopoverComponent);
